import { IResearchWorkItem } from "features/Research/types";
import { apiClient } from "lib/apiClient";

export interface IResearchUnclaimRequest {
  workItemId: string;
  version: number;
  reason?: string;
}

export const unclaimResearchWorkItem = async ({
  workItemId,
  version,
  reason,
}: IResearchUnclaimRequest): Promise<IResearchWorkItem> => {
  const response = await apiClient.post(
    `/research/work-items/${workItemId}/unclaim`,
    { version, reason }
  );

  return response.data;
};
